<template>
  <div class="page-ct">
    <i class="material-icons spinning-icon">hourglass_full</i>
    <br />
    login...
    <br />
  </div>
</template>
<script>
// import AuthService from '@/services/auth.service'

export default {
  beforeRouteEnter: async (to, from, next) => {
    // const as = new AuthService()
    // await as.doLogout()
    next()
  },
  created() {
    if (!this.$auth.user) {
      this.$auth.loginWithRedirect()
    } else {
      this.$router.push({
        name: 'home',
      })
    }
  },
}
</script>
<style scoped>
.page-ct {
  height: calc(100vh);
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: center;
  padding-bottom: 10%;
  text-align: center;
}
.spinning-icon {
  font-size: 100px !important;
  color: #8a8a8a !important;
  margin-bottom: 15px;
}
</style>
